<div #InitiateAppLauncherDiv>
    <ngx-smart-modal #InitiateAppLauncherModal
                     [identifier]="modalType"
                     [closable]="true"
                     customClass="modal-dialog-wide"
                     showCloseButton
                     showConfirmButton>

        <app-bs-app-launcher 
            [displayLaunch]="true"
            [displayExpandedContent]="false"
            [createAppLaunchUrl]="createAppLaunchUrl"
        >
        </app-bs-app-launcher>


    </ngx-smart-modal>
</div>